import { observer } from "mobx-react-lite";
import { state } from "../../state/stateManager";
import Merchants from "./Merchants";
const MerchantsFrame = observer(() => {
    return (<Merchants />);
});

export default MerchantsFrame;